// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/profile-circle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/icons/lock.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/icons/eye-slash.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/icons/eye.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: space-between;
}

.login-page .left {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #ffffff;
}

.login-page .left h1 {
    color: #036323;
    text-align: center;
    font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%; /* 52px */
    margin-bottom: 80px;
}

.login-page form {
    width: 540px;
    text-align: center;
}

.login-page form .input-wrap {
    position: relative;
    width: 100%;
    height: 48px;
    margin-bottom: 30px;
}

.login-page form .input-wrap .bg {
    position: absolute;
    top: 50%;
    left: 24px;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
            mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    -webkit-mask-position: center;
            mask-position: center;
    -webkit-mask-repeat: no-repeat;
            mask-repeat: no-repeat;
    -webkit-mask-size: cover;
            mask-size: cover;
    background-color: #A9A9A9;
}

.login-page form .input-wrap .bg.bg2 {
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
            mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.login-page form .input-wrap .eye-slash {
    position: absolute;
    top: 50%;
    right: 24px;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
            mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    -webkit-mask-position: center;
            mask-position: center;
    -webkit-mask-repeat: no-repeat;
            mask-repeat: no-repeat;
    -webkit-mask-size: cover;
            mask-size: cover;
    background-color: #A9A9A9;
    cursor: pointer;
}

.login-page form .input-wrap .eye-open {
    position: absolute;
    top: 50%;
    right: 24px;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
            mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    -webkit-mask-position: center;
            mask-position: center;
    -webkit-mask-repeat: no-repeat;
            mask-repeat: no-repeat;
    -webkit-mask-size: cover;
            mask-size: cover;
    background-color: #A9A9A9;
    cursor: pointer;
}

.login-page form input {
    width: 100%;
    height: 100%;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #CDCDCD;
    background-color: transparent;
    padding: 10px;
    padding-left: 64px;
    padding-right: 64px;
}

.login-page form input::placeholder {
    color: #A9A9A9;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.login-page form button {
    width: 117px;
    height: 48px;
    border: none;
    border-radius: 10px;
    background: #036323;
    color: #FFF;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.login-page .right {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #F2F2F2;
}

.login-page .right img {
    width: 308px;
    height: 344px;
    margin-bottom: 40px;
}

.karantin {
    color: #036323;
    font-family: Montserrat;
    font-weight: 700;
    font-size: 64px;
}`, "",{"version":3,"sources":["webpack://./src/views/login/login.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,2DAAwD;YAAxD,mDAAwD;IACxD,6BAAqB;YAArB,qBAAqB;IACrB,8BAAsB;YAAtB,sBAAsB;IACtB,wBAAgB;YAAhB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,2DAA8C;YAA9C,mDAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,2DAAmD;YAAnD,mDAAmD;IACnD,6BAAqB;YAArB,qBAAqB;IACrB,8BAAsB;YAAtB,sBAAsB;IACtB,wBAAgB;YAAhB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,2DAA6C;YAA7C,mDAA6C;IAC7C,6BAAqB;YAArB,qBAAqB;IACrB,8BAAsB;YAAtB,sBAAsB;IACtB,wBAAgB;YAAhB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".login-page {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: space-between;\n}\n\n.login-page .left {\n    width: 50%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    background-color: #ffffff;\n}\n\n.login-page .left h1 {\n    color: #036323;\n    text-align: center;\n    font-family: Montserrat;\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 130%; /* 52px */\n    margin-bottom: 80px;\n}\n\n.login-page form {\n    width: 540px;\n    text-align: center;\n}\n\n.login-page form .input-wrap {\n    position: relative;\n    width: 100%;\n    height: 48px;\n    margin-bottom: 30px;\n}\n\n.login-page form .input-wrap .bg {\n    position: absolute;\n    top: 50%;\n    left: 24px;\n    transform: translateY(-50%);\n    width: 24px;\n    height: 24px;\n    mask-image: url('../../assets/icons/profile-circle.png');\n    mask-position: center;\n    mask-repeat: no-repeat;\n    mask-size: cover;\n    background-color: #A9A9A9;\n}\n\n.login-page form .input-wrap .bg.bg2 {\n    mask-image: url('../../assets/icons/lock.png');\n}\n\n.login-page form .input-wrap .eye-slash {\n    position: absolute;\n    top: 50%;\n    right: 24px;\n    transform: translateY(-50%);\n    width: 24px;\n    height: 24px;\n    mask-image: url('../../assets/icons/eye-slash.png');\n    mask-position: center;\n    mask-repeat: no-repeat;\n    mask-size: cover;\n    background-color: #A9A9A9;\n    cursor: pointer;\n}\n\n.login-page form .input-wrap .eye-open {\n    position: absolute;\n    top: 50%;\n    right: 24px;\n    transform: translateY(-50%);\n    width: 24px;\n    height: 24px;\n    mask-image: url('../../assets/icons/eye.png');\n    mask-position: center;\n    mask-repeat: no-repeat;\n    mask-size: cover;\n    background-color: #A9A9A9;\n    cursor: pointer;\n}\n\n.login-page form input {\n    width: 100%;\n    height: 100%;\n    flex-shrink: 0;\n    border-radius: 10px;\n    border: 1px solid #CDCDCD;\n    background-color: transparent;\n    padding: 10px;\n    padding-left: 64px;\n    padding-right: 64px;\n}\n\n.login-page form input::placeholder {\n    color: #A9A9A9;\n    font-family: Montserrat;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.login-page form button {\n    width: 117px;\n    height: 48px;\n    border: none;\n    border-radius: 10px;\n    background: #036323;\n    color: #FFF;\n    font-family: Montserrat;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.login-page .right {\n    width: 50%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    background-color: #F2F2F2;\n}\n\n.login-page .right img {\n    width: 308px;\n    height: 344px;\n    margin-bottom: 40px;\n}\n\n.karantin {\n    color: #036323;\n    font-family: Montserrat;\n    font-weight: 700;\n    font-size: 64px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
